/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  /**
   * Mobile Product Grid Image Hover
   * Shows secondary product image on touch devices
   */
  function initMobileProductImageHover() {
    // Only run on touch devices
    if (!document.documentElement.classList.contains('supports-touch')) {
      return;
    }

    const productItems = document.querySelectorAll('[data-product-grid-item]');
    
    if (productItems.length === 0) {
      return;
    }

    // Handle touch on product items
    productItems.forEach(function(item) {
      const productImage = item.querySelector('[data-product-image]');
      const secondImage = item.querySelector('.product-item__bg__under');
      
      if (!productImage || !secondImage) {
        return;
      }

      // Add touch event to product image
      productImage.addEventListener('touchstart', function(e) {
        // Don't trigger if touching a button or link inside
        if (e.target.closest('button') || e.target.closest('.quick-add__holder')) {
          return;
        }

        // Toggle active state on this product
        const isActive = item.classList.contains('is-touched');
        
        // Remove active state from all products
        productItems.forEach(function(otherItem) {
          otherItem.classList.remove('is-touched');
        });

        // Add active state to this product if it wasn't active
        if (!isActive) {
          item.classList.add('is-touched');
        }
      }, { passive: true });
    });

    // Remove active state when scrolling
    let scrollTimeout;
    window.addEventListener('scroll', function() {
      clearTimeout(scrollTimeout);
      scrollTimeout = setTimeout(function() {
        productItems.forEach(function(item) {
          item.classList.remove('is-touched');
        });
      }, 150);
    }, { passive: true });

    // Remove active state when touching outside products
    document.addEventListener('touchstart', function(e) {
      if (!e.target.closest('[data-product-grid-item]')) {
        productItems.forEach(function(item) {
          item.classList.remove('is-touched');
        });
      }
    }, { passive: true });
  }

  // Initialize on page load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initMobileProductImageHover);
  } else {
    initMobileProductImageHover();
  }

  // Re-initialize when new products are loaded (e.g., AJAX pagination)
  document.addEventListener('shopify:section:load', initMobileProductImageHover);

  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
